import { Flex, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { DateTimeRangeDropdown } from '~/components/shared/DateTimeRangeDropdown'
import { FilterButton } from '~/components/shared/FilterButton'
import { useGetCustomStatuses } from '~/queries/customStatusQueries'

import { useDashboardContext } from '../context/DashboardContext'

const AVAILABILITY = {
  Online: 'online',
  Away: 'away',
} as const

const AgentStatusFilters = () => {
  const { pbxId } = useDashboardContext()
  const { t } = useTranslation()
  const { data: customStatuses } = useGetCustomStatuses(pbxId)
  const statusFilterData = [
    {
      title: t('agentStatusFilters.availability'),
      rows: [
        {
          items: [
            {
              title: t('agentStatusFilters.items.online'),
              data: AVAILABILITY.Online,
            },
            {
              title: t('agentStatusFilters.items.away'),
              data: AVAILABILITY.Away,
            },
          ],
        },
      ],
    },
    {
      title: t('agentStatusFilters.status'),
      rows: [
        {
          items:
            customStatuses?.map((status) => ({
              title: status.name,
              data: status.id,
            })) ?? [],
        },
      ],
    },
  ]
  return (
    <Flex
      width={'100%'}
      height={'4.5rem'}
      padding={'0rem 1.25rem'}
      justifyContent={'space-between'}
      alignItems={'center'}
      alignSelf={'stretch'}
      borderBottom={'2px solid var(--chakra-colors-border-default)'}
      background={'var(--chakra-colors-bg-default);'}
    >
      <Text
        fontSize={'1.25rem'}
        fontWeight={'800'}
        lineHeight={'1.75rem'}
        color={'var(--chakra-colors-fg-default);'}
      >
        {t('agentStatusFilters.header')}
      </Text>
      <Flex gap={'0.75rem'} display={'none'}>
        <DateTimeRangeDropdown
          onValueChange={() => {}}
          useQuickActionButton={false}
          dateTimeRange={undefined}
        />
        <FilterButton
          filterData={statusFilterData}
          title={t('tooltips.filter')}
          activeFiltersCount={0}
          onFilterChangesApplied={() => {}}
          useQuickActionButton={false}
        />
      </Flex>
    </Flex>
  )
}

export default AgentStatusFilters
